import { db } from "../firebase";
import { collection, addDoc, getDocs, Timestamp } from "firebase/firestore";

// Jalankan fungsi ini 1x untuk membuat data awal
export const initPengumuman = async () => {
  try {
    const pengumumanRef = collection(db, "pengumuman");
    const snapshot = await getDocs(pengumumanRef);

    if (!snapshot.empty) {
      console.log("✅ Koleksi 'pengumuman' sudah ada. Tidak perlu inisialisasi ulang.");
      return;
    }

    // Tambahkan contoh data awal
    const sampleData = [
      {
        judul: "Penerimaan Siswa Baru Tahun Ajaran 2025/2026 Telah Dibuka!",
        isi: "Pendaftaran online dibuka mulai 10 Oktober hingga 15 Desember 2025. Ayo segera daftarkan diri kalian melalui website resmi sekolah!",
        tanggal: Timestamp.now(),
        gambar_url: "https://res.cloudinary.com/dlszfywbl/image/upload/v1739639999/banner-ppdb.jpg",
      },
      {
        judul: "Pengumuman Libur Maulid Nabi Muhammad SAW",
        isi: "Dalam rangka memperingati Maulid Nabi Muhammad SAW, kegiatan belajar diliburkan pada tanggal 15–17 Oktober 2025.",
        tanggal: Timestamp.now(),
        gambar_url: "https://res.cloudinary.com/dlszfywbl/image/upload/v1739638888/banner-maulid.jpg",
      },
      {
        judul: "Kegiatan Lomba Hari Guru Nasional",
        isi: "SMP Muhammadiyah 2 Bolang akan mengadakan berbagai lomba antar siswa untuk memperingati Hari Guru Nasional pada 25 November 2025.",
        tanggal: Timestamp.now(),
        gambar_url: "https://res.cloudinary.com/dlszfywbl/image/upload/v1739637777/banner-hariguru.jpg",
      },
    ];

    for (const data of sampleData) {
      await addDoc(pengumumanRef, data);
    }

    console.log("🎉 Koleksi 'pengumuman' berhasil dibuat dan diisi dengan data awal!");
  } catch (err) {
    console.error("❌ Gagal membuat koleksi pengumuman:", err);
  }
};
